import { render, staticRenderFns } from "./ClientListas.vue?vue&type=template&id=4bebcf3e&scoped=true&"
import script from "./ClientListas.vue?vue&type=script&lang=js&"
export * from "./ClientListas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebcf3e",
  null
  
)

export default component.exports